import { render, staticRenderFns } from "./editCustomer.vue?vue&type=template&id=52aaab52&scoped=true"
import script from "./editCustomer.vue?vue&type=script&lang=js"
export * from "./editCustomer.vue?vue&type=script&lang=js"
import style0 from "./editCustomer.vue?vue&type=style&index=0&id=52aaab52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aaab52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52aaab52')) {
      api.createRecord('52aaab52', component.options)
    } else {
      api.reload('52aaab52', component.options)
    }
    module.hot.accept("./editCustomer.vue?vue&type=template&id=52aaab52&scoped=true", function () {
      api.rerender('52aaab52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/editCustomer.vue"
export default component.exports